<template>
    <div class="about_zz">
        <content-card v-for="( item, index ) in items" :key="index" :items="item"></content-card>
    </div>
</template>
<script>
import ContentCard from "@/components/contentComp/ContentCard.vue";

export default {
    name: "zz",
    components: {
        ContentCard,
    },
    data() {
        return {
            items:[
                {
                    title:{
                        icon_title: "主张",
                    },
                    type: "TitleimgTxT",
                    content:[
                        {
                            title:"1/新商邦精神",
                            img_content: [
                                {
                                    width: "91.8px",
                                    height: "91px",
                                    url: require("@/assets/gywm/zhuzhang/icon_1.png"),
                                    img_title: "我们提倡：<br/>老板不分大小，不以成败论英雄！",
                                },
                                {
                                    width: "95.14px",
                                    height: "91px",
                                    url: require("@/assets/gywm/zhuzhang/icon_2.png"),
                                    img_title: "我们提倡：<br/>所有人向所有人学习，<br/>所有人支持所有人！",
                                },
                                {
                                    width: "86.77px",
                                    height: "91px",
                                    url: require("@/assets/gywm/zhuzhang/icon_3.png"),
                                    img_title: "我们提倡：<br/>越平凡，越非凡！<br/>向红尘学习，向红尘致敬！<br/>做红尘中的凡人，创红尘中的大业！",
                                },
                            ],
                            txt_list:[
                                "1、世界上只有一种英雄主义，就是看清生活的真相之后依然热爱生活。",
                                "2、一边拥有，一边失去； 一边选择，一边放弃。",
                                "3、失败了拼死相救，成功了举杯相贺。",
                                "4、侠义，是比契约精神更高级的商业合作精神。",
                                "5、在一起、了不起，若同行、必不负！",
                            ],
                        },
                        {
                            title:"2/新酱酒主义",
                            img_content: [
                                {
                                    width: "367px",
                                    height: "140px",
                                    url: require("@/assets/gywm/zhuzhang/zz1.jpg"),
                                    img_title: "我们提倡：<br/>不劝你多喝，但陪你喝多！",
                                },
                                {
                                    width: "368px",
                                    height: "140px",
                                    url: require("@/assets/gywm/zhuzhang/zz2.jpg"),
                                    img_title: "我们提倡：<br/>以酒成欢，以酒成礼，以酒养生！",
                                },
                                {
                                    width: "368px",
                                    height: "140px",
                                    url: require("@/assets/gywm/zhuzhang/zz3.jpg"),
                                    img_title: "我们提倡：<br/>不装X，喝好酒！",
                                },
                            ],
                            txt_list:[
                                "1、千秋大业红尘中，万丈红尘一杯酒。",
                                "2、如果做不到沉醉任性爱一回，那就尽情放纵喝一杯。",
                                "3、酒的核心作用就是为了醉，醉分三个状态：微醺、酣畅、沉醉。",
                                "4、酸甜苦辣涩，越成熟的人，越喜欢这种复杂的味道。",
                            ],
                        },
                    ],
                },
            ],
        };
    },
};
</script>
<style lang="scss" scoped>
.about_zz{
    width:1315px;
    padding-bottom: 87px !important;
}
</style>